import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'
import Dropzone from 'react-dropzone-legacy'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationCircle,
  faGlobe,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import temporaryFileApi from 'legacy/api/temporary-file'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { withGettext } from 'lib/gettext'

import s from './file-upload.module.scss'

const MAX_SIZE = 100 * 1024 * 1024

const FileUploadItem = createReactClass({
  mixins: [SchemaBranchMixin],

  propTypes: {
    tree: BaobabPropTypes.baobab,
    readOnly: PropTypes.bool,
  },

  schema: {
    pk: null,
    delete: false,
    extension: null,
    thumbnail: null,
    file: null,
    name: null,
    progress: 0,
  },

  isImage() {
    if (!this.state.thumbnail) {
      return false
    }

    const ext = this.state.extension

    if (!ext) {
      return false
    }

    return ['jpeg', 'jpg', 'png', 'gif'].indexOf(ext.toLowerCase()) > -1
  },

  onRemoveClick() {
    this.props.tree.unset()
  },

  renderIcon() {
    if (this.state.pk) {
      if (this.isImage()) {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href={this.state.file}
            target="_blank"
            className={s.image}
            style={{ backgroundImage: `url('${this.state.thumbnail}')` }}
            rel="noreferrer"
          />
        )
      } else {
        return <FontAwesomeIcon icon={faGlobe} className={s.icon} />
      }
    } else {
      if (this.state.progress === 'error') {
        return <FontAwesomeIcon icon={faExclamationCircle} className={s.icon} />
      } else {
        return <img src="/static/img/file-preloader.gif" alt="" />
      }
    }
  },

  render() {
    return (
      <tr>
        <td className={s.thumbnail}>{this.renderIcon()}</td>

        <td>
          {this.state.pk ? (
            <a
              className={s.link}
              href={this.state.file}
              target="_blank"
              rel="noreferrer"
            >
              {this.state.name}
            </a>
          ) : (
            <span>
              <span className={s.name}>{this.state.name}</span>

              <span className={s.progress}>
                {this.state.progress === 'error' ? (
                  <span>An error has occurred</span>
                ) : (
                  <span>{this.state.progress}% is uploaded</span>
                )}
              </span>
            </span>
          )}
        </td>

        <td className={s.delele__cell}>
          {!this.props.readOnly && (
            <button
              type="button"
              className={s.delete__btn}
              onClick={this.onRemoveClick}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </button>
          )}
        </td>
      </tr>
    )
  },
})

const FileUpload = createReactClass({
  mixins: [FormComponentMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    helpText: PropTypes.string,
    label: PropTypes.string,
    accepts: PropTypes.any,
  },

  getDefaultProps() {
    return {
      readOnly: false,
      accepts:
        'image/*,.doc,.docx,.xls,.xlsx,.pdf,.odt,.ods,.rtf,.prj,.shp,.kml,.shx,.dbf,.sbn,.sbx',
    }
  },

  getInitialState() {
    return {
      limitExceededFiles: [],
    }
  },

  onDrop(files) {
    const filesCursor = this.getCursor()
    if (this.props.readOnly) {
      return
    }

    let limitExceededFiles = []
    _.map(files, (file) => {
      if (file.size <= MAX_SIZE) {
        const queueId = _.uniqueId()
        filesCursor.push({
          queueId,
          name: file.name,
          progress: 0,
        })
        const currentFileCursor = filesCursor.select({ queueId })

        temporaryFileApi
          .upload(file, (progressEvent) => {
            currentFileCursor.exists() &&
              currentFileCursor.set(
                'progress',
                parseInt((progressEvent.loaded / progressEvent.total) * 100, 10)
              )
          })
          .then(
            (data) =>
              currentFileCursor.exists() && currentFileCursor.merge(data)
          )
          .catch(
            () =>
              currentFileCursor.exists() &&
              currentFileCursor.set('progress', 'error')
          )
      } else {
        limitExceededFiles.push(file.name)
      }
    })
    this.setState({ limitExceededFiles })
  },

  onOpenClick() {
    this.refs.dropzone.open()
  },

  renderErrors() {
    if (!this.state.limitExceededFiles.length) {
      return null
    }

    return (
      <div>
        {this.props.gettext('File size limit exceeded for next files:')}

        <ul>
          {_.map(this.state.limitExceededFiles, (fileName, index) => (
            <li key={index}>{fileName}</li>
          ))}
        </ul>
      </div>
    )
  },

  render() {
    const { helpText, label, gettext } = this.props
    const cursor = this.getCursor()

    return (
      <div>
        <div className={s.help__block}>
          <label>{label}</label>

          <div dangerouslySetInnerHTML={{ __html: helpText }} />
        </div>

        <div>
          {this.renderErrors()}

          <Dropzone
            onDrop={this.onDrop}
            disableClick
            activeClassName={s._active}
            className={s.dropzone}
            ref="dropzone"
            accept={this.props.accepts}
          >
            <table className={s.table}>
              <tbody>
                {cursor.map((cursor, index) => (
                  <FileUploadItem
                    key={index}
                    tree={cursor}
                    readOnly={this.props.readOnly}
                  />
                ))}
              </tbody>
            </table>

            {!this.props.readOnly && (
              <div className={s.wrapper}>
                <button
                  className={s.add__btn}
                  onClick={this.onOpenClick}
                  type="button"
                >
                  {gettext('Add files')}
                </button>

                <div className={s.dropzone__text}>
                  <span className={s.text__default}>
                    {gettext('or drag & drop files here')}
                  </span>

                  <span className={s.text__active}>
                    {gettext('drop files here')}
                  </span>
                </div>
              </div>
            )}
          </Dropzone>
        </div>
      </div>
    )
  },
})

export default withGettext(FileUpload)
